import React from 'react';
import { useComponents } from '@tencent/dz-elements';
import { useMessageModel, useLeaveModel, useConsultModel } from '../../../hooks';
import { ReplyType } from '../../../const';
import styles from './style/index.less';
import { useReportService } from './useReportService';
import { jsonParseSandbox } from '../../../utils';
export var DetainmentModal = function () {
    var leaveModel = useLeaveModel();
    var _a = leaveModel.questions, questions = _a === void 0 ? [] : _a, visible = leaveModel.visible;
    var _b = useComponents(), View = _b.View, Text = _b.Text, Modal = _b.Modal;
    var messageModel = useMessageModel();
    var report = useReportService({ questions: questions.map(function (item) { return item === null || item === void 0 ? void 0 : item.question; }), visible: visible });
    // eslint-disable-next-line @typescript-eslint/naming-convention
    var retention_popup_config = useConsultModel().getConsultConfig().retention_popup_config;
    var hasQuestion = questions.length > 0;
    var isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
    var onClickQuestion = function (question) {
        var detainmentConfig = retention_popup_config ? jsonParseSandbox(retention_popup_config) : {};
        var isSentDirectly = detainmentConfig.is_sent_directly;
        report.questionClickReport(question);
        if (isSentDirectly === 1) {
            // 直接发送
            messageModel.sendMessage(question, { inputType: 'click' });
        }
        else {
            // 带入到输入框
            messageModel.updateInputMessage(question, true);
            // 更新输入框消息来源
            messageModel.updateInputMessageSource({
                module: report.moduleParams,
                payload: {
                    reply_type: ReplyType.retain,
                    reply_content: question,
                },
            });
        }
        // 隐藏
        leaveModel.toggleVisible();
    };
    // 离开
    var onLeave = function () {
        report.leaveReport(hasQuestion ? '确定离开' : '确定');
        window.history.back();
        // 尝试调用微信jsbridge方法关闭在微信默认浏览器中打开的页面，history.back方法在微信浏览器中表现为无反应
        // eslint-disable-next-line @typescript-eslint/naming-convention
        var WeixinJSBridge = window.WeixinJSBridge;
        if (window.WeixinJSBridge && typeof WeixinJSBridge.call === 'function') {
            WeixinJSBridge.call('closeWindow');
        }
    };
    var onCancel = function () {
        if (isIOS) {
            report.cancelReport('取消');
        }
        else if (hasQuestion) {
            report.cancelReport('咨询其他问题');
        }
        else {
            report.cancelReport('取消');
        }
        leaveModel.toggleVisible();
    };
    if (!visible)
        return null;
    return (React.createElement(Modal, { show: true, maskColor: "rgba(0,0,0,.45)", position: "center", style: {
            backgroundColor: '#FFF',
            width: hasQuestion ? '90%' : '70%',
        }, className: styles['modal-container'], maskClosable: true, animationType: "none", id: "detainment-modal" },
        React.createElement(View, { className: styles['detainment-wapper'] },
            React.createElement(Text, { className: styles['detainment-title'], content: hasQuestion ? '确定要离开吗？' : '确定要离开当前咨询页吗？' }),
            hasQuestion && React.createElement(Text, { className: styles['detainment-subtitle'], content: "\u60A8\u53EF\u80FD\u60F3\u54A8\u8BE2\u4EE5\u4E0B\u95EE\u9898" }),
            questions.map(function (item, index) { return (React.createElement(View, { key: index, className: styles['detainment-question'], onClick: function () { return onClickQuestion(item.question); } }, item.question)); })),
        !isIOS && (React.createElement(View, { className: styles['detainment-footer'] },
            React.createElement(View, { className: styles['footer-button'], onClick: onLeave }, hasQuestion ? '确定离开' : '确定'),
            React.createElement(View, { className: styles['footer-button'], onClick: onCancel }, hasQuestion ? '咨询其他问题' : '取 消'))),
        isIOS && (React.createElement(View, { className: styles['detainment-footer'] },
            React.createElement(View, { className: styles['footer-button'], onClick: onCancel }, '关闭')))));
};
